import { render, staticRenderFns } from "./manageParcel.vue?vue&type=template&id=6e1e6fb6&"
import script from "./manageParcel.vue?vue&type=script&lang=js&"
export * from "./manageParcel.vue?vue&type=script&lang=js&"
import style0 from "./manageParcel.vue?vue&type=style&index=0&id=6e1e6fb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports